module.exports = __webpack_public_path__ + "static/img/9.fb3e9c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/9.png
// module id = 6zhy
// module chunks = 0